'use client';

export const Enlarge = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M3.288 30C2.92318 30 2.61724 29.8766 2.37018 29.6298C2.12339 29.3828 2 29.0768 2 28.712V19.0829C2 18.7897 2.09965 18.544 2.29894 18.3458C2.49851 18.1474 2.74557 18.0481 3.04012 18.0481C3.33494 18.0481 3.58022 18.1474 3.77594 18.3458C3.97167 18.544 4.06953 18.7897 4.06953 19.0829V26.4893L26.4893 4.06953H19.0829C18.7897 4.06953 18.544 3.96974 18.3458 3.77018C18.1474 3.57088 18.0481 3.32382 18.0481 3.029C18.0481 2.73445 18.1474 2.48931 18.3458 2.29359C18.544 2.09786 18.7897 2 19.0829 2H28.712C29.0768 2 29.3828 2.12339 29.6298 2.37018C29.8766 2.61723 30 2.92318 30 3.288V12.9171C30 13.2103 29.9004 13.456 29.7011 13.6542C29.5015 13.8526 29.2544 13.9519 28.9599 13.9519C28.6651 13.9519 28.4198 13.8526 28.2241 13.6542C28.0283 13.456 27.9305 13.2103 27.9305 12.9171V5.51071L5.51071 27.9305H12.9171C13.2103 27.9305 13.456 28.0303 13.6542 28.2298C13.8526 28.4291 13.9519 28.6762 13.9519 28.971C13.9519 29.2655 13.8526 29.5107 13.6542 29.7064C13.456 29.9021 13.2103 30 12.9171 30H3.288Z"
				fill="currentColor"
			/>
		</svg>
	);
};
